import React from "react";
import { Link, useLocation } from "react-router-dom";
import LanguageSwitch from "./LanguageSwitch";
import { useLang } from "../lib/LangContext";

// Self-hosted brand asset (source: brand.ariovis.fr, mirrored to avoid hash-URL churn).
const LOGO_BLACK = `${process.env.PUBLIC_URL || ""}/logos/ariovis-logo-light.svg`;

export default function Header() {
  const { lang } = useLang();
  const location = useLocation();
  const isLanding = location.pathname === "/" || location.pathname === "";

  return (
    <header className="sticky top-0 z-40 nav-blur" data-testid="ariovis-header">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
        {isLanding ? (
          <a href="https://www.ariovis.fr" target="_blank" rel="noopener noreferrer" data-testid="header-logo-link" className="flex items-center gap-2">
            <img src={LOGO_BLACK} alt="Ariovis" className="h-6 md:h-7" />
          </a>
        ) : (
          <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2">
            <img src={LOGO_BLACK} alt="Ariovis" className="h-6 md:h-7" />
          </Link>
        )}

        <nav className="flex items-center gap-2 md:gap-6" aria-label="Primary">
          <a
            href="https://www.ariovis.fr/produits"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-link-products"
            className="hidden sm:inline-flex text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors"
          >
            {lang === "en" ? "Ariovis Products" : "Produits Ariovis"}
          </a>
          <a
            href="https://www.ariovis.fr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-link-ariovis"
            className="hidden sm:inline-flex text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors"
          >
            ariovis.fr
          </a>
          <LanguageSwitch />
        </nav>
      </div>
    </header>
  );
}
